module.exports = __webpack_public_path__ + "static/media/failure.15fb9f7f.png";